webpackJsonp([35783957827783],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(30);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectCard = __webpack_require__(64);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ProjectCards = function ProjectCards(props) {
	  return _react2.default.createElement(
	    'div',
	    props,
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid--gutters' },
	      props.children
	    )
	  );
	};
	
	exports.default = function (props) {
	  var projects = props.projects,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ['projects', 'className']);
	
	  var classes = 'projects-grid grid-wrap';
	
	  if (className !== undefined) {
	    classes = classes + ' ' + className;
	  }
	
	  return _react2.default.createElement(
	    ProjectCards,
	    _extends({ className: classes }, rest),
	    projects.map(function (_ref, i) {
	      var node = _ref.node;
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'grid-cell u-full u-md-1of2 u-lg-1of2' },
	        _react2.default.createElement(_ProjectCard2.default, { slug: node.fields.slug,
	          title: node.frontmatter.title,
	          client: node.frontmatter.client,
	          thumbnail: node.frontmatter.thumbnail })
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(28);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(63);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Heading = __webpack_require__(18);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _ProjectCards = __webpack_require__(48);
	
	var _ProjectCards2 = _interopRequireDefault(_ProjectCards);
	
	var _Button = __webpack_require__(47);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var projects = data.projects.edges;
	
	  var pageTitle = "Welcome";
	  var twitterUrl = data.site.siteMetadata.twitterUrl;
	
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'header-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '2', className: 'grid-wrap' },
	        pageTitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'welcome' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrap' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Jorge Mancheno is a product designer based in Brooklyn, NY. You can ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact/' },
	            'say hello'
	          ),
	          ', ',
	          _react2.default.createElement(
	            _gatsbyPluginGoogleAnalytics.OutboundLink,
	            { href: twitterUrl, className: 'link-external', target: '_blank' },
	            'follow him'
	          ),
	          ', or ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/projects/' },
	            'see his work'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Header2.default,
	      { className: 'grid-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '3' },
	        'Recent Projects'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { type: 'link', to: '/projects/', className: 'button--outline button--sm u-sm-full' },
	        'View All'
	      )
	    ),
	    _react2.default.createElement(_ProjectCards2.default, { projects: projects })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2486c6ce13b8ce0ba702.js